import styled from 'styled-components'
import Mixin from 'components/common/Mixin'
import Link from 'components/common/Link/Link'
import Media from 'components/common/Media'
import Theme from 'components/common/Theme/Theme'

export const Wrapper = styled.div`
  padding: 0 0 80px;
`

export const Description = styled.p`
  text-align: center;
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBook(20, 400, 24)};
  margin: 40px 0 60px;
  ${Media.mobile`
    padding: 0 16px;
  `}
`

export const List = styled.ul`
  width: 100%;
  padding: 0;
  margin: 0;
  ${Media.mobile`
    padding: 0 16px;
  `}
`

export const ListItem = styled.li`
  width: 33%;
  display: inline-block;
  text-align: center;
  margin: 20px 0;

  @media screen and (max-width: 500px) {
    width: 50%;
  }
`

export const CustomLink = styled(Link)`
  color: ${Theme.colors.black};
  ${Mixin.font.GothamBook(14, 400, 16)};

  &:hover {
    color: ${Theme.colors.black};
  }

  @media screen and (max-width: 500px) {
    ${Mixin.font.GothamBook(12, 400, 16)};
  }
`
